<template>
	<transition 
			appear
			:appear-active-class="$_crdLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start">
			<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
				<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
					<v-col	:key="contentKey"
							cols="12" sm="6" md="4" lg="3">
						<v-card class="customVCard"
								:color="$_crdLyt_styleCardColor"
								:dark="$_crdLyt_styleCardDark"
								:elevation="$_crdLyt_styleCardElevation"
								:flat="$_crdLyt_styleCardFlat"
								:hover="$_crdLyt_styleCardHover"
								:light="$_crdLyt_styleCardLight"
								:outlined="$_crdLyt_styleCardOutlined"
								:raised="$_crdLyt_styleCardRaised"
								:tile="$_crdLyt_styleCardTile">
							<template v-if="contentVals.title">
								<v-card-title>
									<v-row dense>
										<v-col>
											<span	class="title"
													v-html="$_crdLyt_langContentTitle(contentVals)" />
										</v-col>
									</v-row>
								</v-card-title>
							</template>
							<template v-if="contentVals.image">
								<v-row>
									<v-col>
										<v-img	class="customVImg"
												cover 
												:src="$_crdLyt_styleContentImageUrl(contentVals)" />
									</v-col>
								</v-row>
							</template>
							<template v-if="contentVals.subTitle">
								<v-card-title>
									<v-row dense>
										<v-col>
											<span	class="body-2"
													v-html="$_crdLyt_langContentSubTitle(contentVals)" />
										</v-col>
									</v-row>
								</v-card-title>
							</template>
							<template v-if="contentVals.chips">
								<v-card-actions>
									<v-row dense>
										<template v-for="(chipVals, chipKey) in sortObject(contentVals.chips)">
											<v-col	:key="chipKey"
													cols="auto">
												<v-chip pill
														:color="$_crdLyt_styleChipColor"
														:dark="$_crdLyt_styleChipDark"
														:label="$_crdLyt_styleChipLabel"
														:light="$_crdLyt_styleChipLight"
														:outlined="$_crdLyt_styleChipOutlined"
														:small="$_crdLyt_styleChipSmall"
														:text-color="$_crdLyt_styleChipTextColor">
													<v-avatar
															left
															:color="$_crdLyt_getChanceColor(chipKey)">
														#
													</v-avatar>
													<span v-text="chipKey" />
												</v-chip>
											</v-col>
										</template>
									</v-row>
								</v-card-actions>
							</template>
							<template v-if="!isFalse($_crdLyt_langContentText(contentVals))">
								<v-card-text>
									<v-row dense>
										<v-col>
											<span	class="markdown"
													v-html="marked($_crdLyt_langContentText(contentVals))" />
										</v-col>
									</v-row>
								</v-card-text>
							</template>
							<template v-if="contentVals.actionButtons">
								<v-card-actions class="cardActions_">
									<v-row dense>
										<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
											<v-col :key="actionButtonKey" cols="auto">
												<v-btn	class="customVBtn"
														:block="$_crdLyt_styleActionButtonBlock"
														:color="$_crdLyt_styleActionButtonColor"
														:dark="$_crdLyt_styleActionButtonDark"
														:depressed="$_crdLyt_styleActionButtonDepressed"
														:elevation="$_crdLyt_styleActionButtonElevation"
														:large="$_crdLyt_styleActionButtonLarge"
														:light="$_crdLyt_styleActionButtonLight"
														:outlined="$_crdLyt_styleActionButtonOutlined"
														:rounded="$_crdLyt_styleActionButtonRounded"
														:small="$_crdLyt_styleActionButtonSmall"
														:text="$_crdLyt_styleActionButtonFlat"
														@click="openLink(actionButtonVals.link)"
														v-text="$_crdLyt_langActionButtonTitle(actionButtonVals)" />
											</v-col>
										</template>
									</v-row>
								</v-card-actions>
							</template>
						</v-card>
					</v-col>
				</template>
			</template>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'CardLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				colors_: {}
			}
		},
		computed: {
			// lang 
			// (content)
			$_crdLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_crdLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_crdLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_crdLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_crdLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_crdLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_crdLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_crdLyt_styleCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'card')
			},
			$_crdLyt_styleCardColor() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_crdLyt_styleCardDark() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_crdLyt_styleCardElevation() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_crdLyt_styleCardFlat() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_crdLyt_styleCardHover() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_crdLyt_styleCardLight() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_crdLyt_styleCardOutlined() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_crdLyt_styleCardRaised() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_crdLyt_styleCardTile() {
				const self_ = this;
				const card_ = self_.$_crdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_crdLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_crdLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_crdLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_crdLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_crdLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_crdLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_crdLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_crdLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_crdLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_crdLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_crdLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_crdLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_crdLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_crdLyt_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'chip')
			},
			$_crdLyt_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_crdLyt_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_crdLyt_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_crdLyt_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_crdLyt_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_crdLyt_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_crdLyt_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_crdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			// (content)
			$_crdLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_crdLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_crdLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		methods: {
			$_crdLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor()
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.cardActions_ {
		padding-bottom: 16px;
	}
</style>
